import { useState } from 'react';
import { CONTRACT_TYPE_CLIENT, ContractDto, IPagingData } from '@sr/dto';
import { useClientInvoices } from 'entities/client-invoices-list/lib/client-invoices-list.hook';
import { useSupplierInvoices } from 'entities/client-invoices-list/lib/supplier-invoices-list.hook';
import { InvoicesList, SupplierInvoicesList } from 'entities/invoice/list';

const DEFAULT_PAGING: IPagingData = {
  page: 0,
  itemsPerPage: 25,
};

export const ContractInvoicesList = ({ contract }: { contract: ContractDto }) => {
  const [paging, setPaging] = useState<IPagingData>(DEFAULT_PAGING);
  const filterString = `contractId=${contract.id}`;

  const clientInvoices = useClientInvoices(paging, filterString);
  const supplierInvoices = useSupplierInvoices(paging, undefined, filterString);

  if (contract.type === CONTRACT_TYPE_CLIENT) {
    return <InvoicesList collection={clientInvoices.collection} paging={paging} onChangePaging={setPaging} />;
  }

  return <SupplierInvoicesList collection={supplierInvoices.collection} paging={paging} onChangePaging={setPaging} />;
};
